export default __webpack_public_path__ + "static/media/Gradient_1_Dots.a7bdf11a.svg";